import { GroupId } from '@sr/types';
import { memo } from 'react';
import { getGroupColor, getGroupInfo } from './group-utils';
import useStore from 'store';
import { useMessageCountForGroup } from 'store/selectors/messages';
import {
  BestPracticesIcon,
  Box,
  CompletenessIcon,
  FormattingIcon,
  ImpactIcon,
} from 'v1/ui';

export const GroupHeader = memo(function GroupHeader({
  active,
  groupId,
}: {
  active: boolean;
  groupId: GroupId;
}) {
  const deselectGroup = useStore.useDeselectGroup();
  const numMessages = useMessageCountForGroup(groupId);
  const selectGroup = useStore.useSelectGroup();
  const { title } = getGroupInfo(groupId, numMessages);

  function handleClick() {
    if (active) {
      deselectGroup();
    } else {
      selectGroup(groupId);
    }
  }

  function subtitle() {
    switch (numMessages) {
      case 0:
        return 'No issues found';
      case 1:
        return '1 issue found';
      default:
        return `${numMessages} issues found`;
    }
  }

  return (
    <Box
      onClick={handleClick}
      sx={{ px: 4, py: 3, cursor: 'pointer', userSelect: 'none' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: 18,
          fontWeight: 600,
          color: 'black50',
        }}
      >
        <Box>
          <Box variant="text.baseEmphasis">{title}</Box>
          <Box variant="text.caption" sx={{ color: 'black70' }}>
            {subtitle()}
          </Box>
        </Box>
        <GroupIcon groupId={groupId} />
      </Box>
    </Box>
  );
});

const GroupIcon = memo(function GroupIcon({ groupId }: { groupId: GroupId }) {
  const color = getGroupColor(groupId);
  switch (groupId) {
    case 'best-practices':
      return <BestPracticesIcon color={color} />;
    case 'completeness':
      return <CompletenessIcon color={color} />;
    case 'formatting':
      return <FormattingIcon color={color} />;
    case 'impact':
      return <ImpactIcon color={color} />;
  }
  return <CompletenessIcon color={color} />;
});
